<template>
   <div style="padding:20px">
        <div class="vld-parent">
            <loading :active.sync="isLoading" loader= 'bars' 
            :can-cancel="true" 
            :on-cancel="onCancel"
            :is-full-page="fullPage"></loading>
        </div>
        <div class="heading text-center">
            <img class="dividerline" src="../../assets/img/sep.png" alt="">
            <h2>Video Gallery</h2>
            <img class="dividerline" src="../../assets/img/sep.png" alt="">
        </div>
        <div class="row">
            <div id="grid-gallery" class="grid-gallery" v-for="(data, i) in videoinfo" :key="i">
                
                <div style="float:left">
                    <br>
                    <iframe width="280" height="160" :src="data" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
                    </iframe>
                </div> &nbsp;
            </div> 
        </div>

        <div class="heading text-center">
            <img class="dividerline" src="../../assets/img/sep.png" alt="">
            <h2>More Playlist</h2>
            <img class="dividerline" src="../../assets/img/sep.png" alt="">
        </div>
        <ul style="text-align:left" v-for="(data, i) in playlist" :key="i+100">
                <li v-html="data"></li>
        </ul>

   </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
  export default {
    name: 'VideoGallery',
    data () {
      return {
        msg: 'Content of VideoGallery',
        isLoading: false,
        fullPage: true,
        info: null,
        videoinfo: null,
        playlist: null
        }
    },
    components: {
       Loading
    },
    methods: {
        onCancel() {
              console.log('User cancelled the loader.')
        }
    },
    mounted () {
    this.isLoading = true;
    axios
      .get(process.env.NODE_API + '/videos')
      .then(response => {
        this.info = response.data
        this.videoinfo=this.info[0].videolinks
        this.playlist=this.info[0].playlist
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
     .finally(() => this.isLoading = false)
  }
}

</script>

<style>
  
</style>



// WEBPACK FOOTER //
// src/components/GalleryItems/VideoGallery.vue